import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'
import { get, isEmpty } from 'lodash'
import { Button, ListItem, Typography } from '@material-ui/core'
import { Link } from 'react-router-dom'

import Icon from '@scoir/components-core/dist/components/Icon'

import rightArrowIcon from 'icons/keyboard-arrow-right.svg'
import favoriteBorderIcon from 'icons/favorite-border.svg'

import useCalendarTransition from 'common/use-calendar-transition'

import './Item.scss'

const Item = ({ onClick, highSchool }) => {
  const handleTransition = useCalendarTransition(highSchool.Id, highSchool.SchoolName)
  const hasFutureAvailability = useMemo(() => {
    const nextAvail = get(highSchool, 'NextVisitAvailability')
    if (isEmpty(nextAvail)) {
      return false
    }
    const date = moment(nextAvail)
    const startOfToday = moment().startOf('day')
    return date.isAfter(startOfToday)
  }, [highSchool])

  const hs = highSchool

  return (
    <ListItem
      className="high-school-list-item-comp"
      onClick={() => onClick()}
      button
    >
      <div className="school-info-wrap">
        <span className="name">{hs.SchoolName}</span>
        <div className="school-info">
          <div className="school-details">
            {hs.City && hs.State && (
              <Typography
                className="school-location"
                color="textSecondary"
              >
                {hs.City}, {hs.State}
              </Typography>
            )}
            {hs.StudentsFollowing > 0 && (
              <p className="students-following">
                <Icon
                  def={favoriteBorderIcon}
                  size="xs"
                  className="favorite-border-icon"
                  beforeText
                />
                {hs.StudentsFollowing} Students
              </p>
            )}
          </div>
          <div className="visit-button">
            {hasFutureAvailability && (
              <Button
                color="primary"
                variant="outlined"
                size="small"
                component={Link}
                className="visit-availability"
                to={`${import.meta.env.BASE_URL}/recruit/visits/view/week?focus=${moment(
                  hs.NextVisitAvailability,
                ).format('YYYYMMDD')}`}
                onClick={handleTransition}
              >
                Visit Availability
              </Button>
            )}
          </div>
        </div>
      </div>
      <div>
        <Icon
          className="right-arrow-button"
          def={rightArrowIcon}
          size="lg"
        />
      </div>
    </ListItem>
  )
}

Item.propTypes = {
  onClick: PropTypes.func.isRequired,
  highSchool: PropTypes.object.isRequired,
  virtual: PropTypes.bool,
}

export default Item
